import I18n from 'I18n';
import Raven from 'raven-js';
import enviro from 'enviro';
import { URLServiceComponent } from '../OAuthIntegrations/URLServiceComponent';
import { postRefreshStatus } from './googleSheetsApi';
import { jsx as _jsx } from "react/jsx-runtime";
export const GoogleSheetsServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthFailed,
  onAuthSucceeded,
  reconnectStarted,
  timeout,
  url
}) => {
  const handleAuthSucceeded = code => {
    void postRefreshStatus().then(() => {
      onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(code);
    }).catch(err => {
      if (enviro.isQa()) {
        console.error(err);
      }
      Raven.captureException(err, {
        extra: {
          message: 'Error refreshing OAuth status for Google Sheets'
        }
      });
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error: err,
        errorMessage: I18n.text('reconnect.errors.updateAccountFailed')
      });
    });
  };
  return /*#__PURE__*/_jsx(URLServiceComponent, {
    metadata: metadata,
    onAuthSucceeded: handleAuthSucceeded,
    onAuthCancelled: onAuthCancelled,
    onAuthFailed: onAuthFailed,
    reconnectStarted: reconnectStarted,
    timeout: timeout,
    url: url
  });
};